import type { SVGProps } from 'react'

export const CalendarStar = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M13.1225 2.16602V5.28857" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M6.87744 2.16602V5.28857" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2.97427 7.63251H17.0257" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.4645 3.72852H4.53555C3.67294 3.72852 2.97427 4.42719 2.97427 5.28979V15.4381C2.97427 16.3007 3.67294 16.9994 4.53555 16.9994H15.4645C16.3271 16.9994 17.0257 16.3007 17.0257 15.4381V5.28979C17.0257 4.42719 16.3271 3.72852 15.4645 3.72852Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.84885 10.2428C9.92982 10.0786 10.097 9.97461 10.2801 9.97461C10.4632 9.97461 10.6305 10.0786 10.7114 10.2428L11.0629 10.9554C11.1326 11.0974 11.268 11.1957 11.4246 11.218L12.2119 11.3352C12.3929 11.3618 12.5431 11.4887 12.5995 11.6627C12.6559 11.8367 12.6087 12.0276 12.4778 12.1553L11.9087 12.7102C11.7951 12.8204 11.7435 12.9798 11.771 13.1356L11.9049 13.9184C11.936 14.0987 11.862 14.2811 11.714 14.3887C11.5659 14.4963 11.3696 14.5103 11.2077 14.425L10.5048 14.0555C10.364 13.9803 10.195 13.9803 10.0542 14.0555L9.35191 14.425C9.19003 14.5103 8.99371 14.4963 8.84567 14.3887C8.69763 14.2811 8.6236 14.0987 8.65478 13.9184L8.78867 13.1356C8.81574 12.9798 8.7642 12.8206 8.65092 12.7102L8.08445 12.1553C7.9535 12.0277 7.90623 11.8369 7.96249 11.6629C8.01875 11.489 8.1688 11.362 8.34966 11.3352L9.13627 11.218C9.29287 11.1957 9.4283 11.0974 9.49803 10.9554L9.84885 10.2428Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
